import { values } from 'lodash-es'
import { types } from 'mobx-state-tree'

import { ReferenceFreightieOrUser } from '../Actors'
import { FORTO_AVATAR, TAvatarType } from '../avatars/AvatarType'
import { getAvatar, getAvatarType } from '../avatars/avatarUtils'
import { IActivityMessageSection, IActivityTitle, TEXT } from '../messages/MessageSectionType'
import { Activity } from './Activity'

enum CompanyUserActionEnum {
  ADDED = 'added',
  DELETED = 'deleted',
  RE_INVENTED = 're-invited',
  CONFIRMED = 'confirmed',
}

const CompanyUserAction = types.enumeration('CompanyUserAction', values(CompanyUserActionEnum))

const userActionTranslationMap: Record<CompanyUserActionEnum, string> = {
  [CompanyUserActionEnum.ADDED]: 'activity_log-company_user_added',
  [CompanyUserActionEnum.DELETED]: 'activity_log-company_user_deleted',
  [CompanyUserActionEnum.CONFIRMED]: 'activity_log-company_user_confirmed',
  [CompanyUserActionEnum.RE_INVENTED]: 'activity_log-company_user_re_invited',
}

export const CompanyUserActivity = types
  .compose(
    'CompanyUserActivity',
    Activity,
    types.model({
      authorActor: ReferenceFreightieOrUser,
      targetActor: ReferenceFreightieOrUser,
      action: CompanyUserAction,
    })
  )
  .preProcessSnapshot((snapshot) => {
    const { userAuthor_id, targetCompanyUser_id } = snapshot
    return {
      ...snapshot,
      authorActor: userAuthor_id,
      targetActor: targetCompanyUser_id,
    }
  })
  .views((self) => ({
    get avatarType(): TAvatarType {
      if (!self.authorActor || !self.targetActor) {
        return FORTO_AVATAR
      }
      return getAvatarType(self.authorActor)
    },
    get avatar(): string {
      return getAvatar(self.authorActor)
    },
    get messageContent(): IActivityMessageSection[] {
      return [
        {
          type: TEXT,
          content:
            !self.targetActor || !self.authorActor
              ? 'activity-feed_deleted_user_desc'
              : userActionTranslationMap[self.action],
          translate: true,
          translationParams: {
            targetUserName: self.targetActor ? self.targetActor.name : '',
          },
        },
      ]
    },
    get title(): IActivityTitle {
      if (!self.authorActor || !self.targetActor) {
        return { text: 'activity-feed_deleted_user', translate: true }
      }
      return { text: self.authorActor.name }
    },
  }))

export type TCompanyUserActivity = typeof CompanyUserActivity.Type
